<template>
  <div>
    <b-card no-body>
      <div class="m-2">
        <!-- Table Top -->
        <b-row class="pb-1 d-flex justify-content-between">
          <!-- <b-col cols="8"> -->
          <h4>
            Danh sách
            {{ options.filter(i => i.value === selected)[0].text }}
          </h4>
          <!-- </b-col> -->
          <div>
            <b-button
                class="btn-sm ml-1 mr-2"
                variant="primary"
                @click="ResetSim50K()"
            >
              <feather-icon
                  class="align-text-top"
                  icon="FileMinusIcon"
                  size="16"
              />
              Reset Sim 50K
            </b-button>
            <b-button
                class="btn-sm ml-1 mr-2"
                variant="primary"
                @click="$bvModal.show('modal-import-excel')"
            >
              <feather-icon
                  class="align-text-top"
                  icon="FileMinusIcon"
                  size="16"
              />
              import file
            </b-button>
            <b-button
                v-if="options.find(i => i.value == selected).NewEnabled"
                class="btn-sm"
                variant="primary"
                @click="New()"
            >
              <feather-icon class="align-text-top" icon="PlusIcon" size="16"/>
              Thêm
              {{
                $route.path === "/kho-so"
                    ? "số đơn lẻ"
                    : this.options.filter(i => i.value == this.selected)[0].text
              }}
            </b-button>
            <b-button
                class="btn-sm ml-1 mr-2"
                variant="primary"
                @click="exportExcel"
            >
              <feather-icon
                  class="align-text-top"
                  icon="FileMinusIcon"
                  size="16"
              />
              Export file
            </b-button>
          </div>
          <!-- Per Page -->
        </b-row>

        <b-row>
          <b-col cols="12">
            <div v-if="$route.path === '/kho-so'">
              <TableMerge
                  :dataList="items"
                  :serverParams="serverParams"
                  @handleActions="handleActions"
                  @onColumnFilter="onColumnFilter"
              />
              <div class="row">
                <b-col cols="12">
                  <b-pagination
                      v-model="serverParams.page"
                      :per-page="serverParams.pageSize"
                      :total-rows="totalRecords"
                      class="float-right pt-1 pb-3"
                      first-number
                      last-number
                      @input="handlePage(serverParams.page)"
                  ></b-pagination>
                </b-col>
              </div>
            </div>

            <vue-good-table
                v-else
                :columns="fields"
                :isLoading.sync="isLoading"
                :line-numbers="true"
                :pagination-options="{
                perPage: serverParams.pageSize,
                enabled: true
              }"
                :rows="items"
                :totalRows="totalRecords"
                mode="remote"
                @on-page-change="onPageChange"
                @on-sort-change="onSortChange"
                @on-column-filter="onColumnFilter"
                @on-per-page-change="onPerPageChange"
            >
              <template slot="table-row" slot-scope="props">
                <!-- Column: Action -->
                <span v-if="props.column.field === 'action'">
                  <span>
                    <b-button
                        v-if="
                        options.find(i => i.value == selected).EditEnabled &&
                          props.row.Status !== 20
                      "
                        class="btn-icon"
                        size="sm"
                        variant="primary"
                        @click="Edit(props.row, props.row.id)"
                    >
                      <feather-icon icon="Edit2Icon"/>
                    </b-button>
                    <b-button
                        v-if="
                        options.find(i => i.value == selected).EditEnabled &&
                          props.row.Status == 20
                      "
                        class="btn-icon"
                        size="sm"
                        variant="primary"
                        @click="Edit(props.row, props.row.id)"
                    >
                      <feather-icon icon="EyeIcon"/>
                    </b-button>
                    <b-button
                        v-if="
                        options.find(i => i.value == selected).DeleleEnabled
                      "
                        class="btn-icon"
                        size="sm"
                        style="margin-left: 6px"
                        variant="danger"
                        @click="Delete(props.row, props.row.id)"
                    >
                      <feather-icon icon="TrashIcon"/>
                    </b-button>
                  </span>
                </span>
                <!-- Column: danh muc so -->
                <span
                    v-else-if="
                    selected === 'SimCategory' &&
                      props.column.field === 'seachMoth'
                  "
                    class="d-block text-center"
                >
                  <b-form-checkbox
                      v-model="props.row.IsManySearchMonthly"
                      :disabled="ischeckBox && !props.row.IsManySearchMonthly"
                      inline
                      @change="handelSelectseach(props.row)"
                  >
                  </b-form-checkbox>
                </span>
                <span
                    v-else-if="
                    selected === 'SimCategory' &&
                      props.column.field === 'SimGroupName'
                  "
                    class="row ml-1"
                >
                  <p
                      v-for="i in props.row.SimGroupName"
                      v-if="props.row.SimGroupName"
                      class="bg-primary text-white rounded-sm text-center"
                      style="padding: 0.5rem; margin: 0.5rem"
                  >
                    {{ i }}
                  </p>
                  <p
                      v-if="props.row.SoNut"
                      class="bg-primary text-white rounded-sm text-center"
                      style="padding: 0.5rem; margin: 0.5rem"
                  >
                    {{ props.row.SoNut }}
                  </p>
                  <p
                      v-if="props.row.KenhBan"
                      class="bg-primary text-white rounded-sm text-center"
                      style="padding: 0.5rem; margin: 0.5rem"
                  >
                    {{ props.row.KenhBan }}
                  </p>
                  <p
                      v-if="props.row.Menh"
                      class="bg-primary text-white rounded-sm text-center"
                      style="padding: 0.5rem; margin: 0.5rem"
                  >
                    {{ props.row.Menh }}
                  </p>
                  <p
                      v-if="props.row.Tags"
                      class="bg-primary text-white rounded-sm text-center"
                      style="padding: 0.5rem; margin: 0.5rem"
                  >
                    {{ props.row.Tags }}
                  </p>
                  <p
                      v-if="props.row.LoaiThueBao"
                      class="bg-primary text-white rounded-sm text-center"
                      style="padding: 0.5rem; margin: 0.5rem"
                  >
                    {{ props.row.LoaiThueBao }}
                  </p>
                </span>
                <!-- Column: Common -->
                <span
                    v-else-if="
                    allFields &&
                      allFields.filter(i => i.field == props.column.field) &&
                      allFields.filter(i => i.field == props.column.field)[0] &&
                      allFields.filter(i => i.field == props.column.field)[0]
                        .select2 &&
                      allFields
                        .filter(i => i.field == props.column.field)[0]
                        .select2.filter(
                          i => i.id == props.row[props.column.field]
                        ).length > 0
                  "
                    class="d-block text-center"
                >
                  <b-form-checkbox
                      v-model="props.row.Status === 1 ? 'true' : 'false'"
                      inline
                      @change="handelChangeStatus(props.row)"
                  >
                  </b-form-checkbox>
                </span>
                <span v-else>
                  {{ props.formattedRow[props.column.field] }}
                </span>
              </template>
            </vue-good-table>
          </b-col>
        </b-row>
      </div>
    </b-card>

    <b-modal
        id="modal-edit"
        :title="getTitle()"
        size="lg"
        @ok="handleOk"
        @shown="disableTabIndexes"
    >
      <validation-observer ref="modalEdit">
        <b-row>
          <b-col
              v-for="i in allFields.filter(
              i => i.field !== 'action' && !i.noDisplayform
            )"
              :key="i.field"
              :md="i.cols != null ? i.cols : 6"
              cols="12"
          >
            <validation-provider
                v-if="i.select2 == null"
                #default="{ errors }"
                :name="'\'' + i.label + '\''"
                :rules="
                !i.autoIncrement &&
                (i.field == 'name' || i.field == 'id' || i.required)
                  ? 'required'
                  : ''
              "
            >
              <b-form-group v-if="i.date_time == true" :label="i.label">
                <b-form-datepicker
                    v-model="currentItem[i.field]"
                    :date-format-options="{
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit'
                  }"
                    :state="errors.length > 0 ? false : null"
                    locale="vi-VN"
                />
              </b-form-group>
              <b-form-group v-else>
                <p>
                  {{
                    i.label
                  }}<span v-if="i.required" style="color: red"> *</span>
                </p>
                <b-form-input
                    v-model="currentItem[i.field]"
                    :disabled="
                    ((i.field === 'id' || i.disabled) && editMode) ||
                      i.autoIncrement ||
                      i.hidden ||
                      (i.disabled && selected == 'Inventory') ||
                      (selected == 'Inventory' &&
                        currentItem.Status == 20 &&
                        editMode)
                  "
                    :placeholder="i.autoIncrement ? 'Hệ thống tự sinh' : i.label"
                    :state="errors.length > 0 ? false : null"
                    @keyup.enter="handleKeyUP($event, i.field)"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
            <validation-provider
                v-else
                #default="{ errors }"
                :name="'\'' + i.label + '\''"
                :rules="
                i.field == 'name' || i.field == 'id' || i.required
                  ? 'required'
                  : ''
              "
            >
              <b-form-group v-if="i.date_time == true" :label="i.label">
                <b-form-datepicker
                    v-model="currentItem[i.field]"
                    :date-format-options="{
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit'
                  }"
                    :state="errors.length > 0 ? false : null"
                    locale="vi-VN"
                />
              </b-form-group>
              <b-form-group v-else>
                <p>
                  {{
                    i.label
                  }}<span v-if="i.required" style="color: red"> *</span>
                </p>
                <Select2
                    v-model="currentItem[i.field]"
                    :disabled="
                    selected == 'Inventory' &&
                      currentItem.Status == 20 &&
                      editMode
                  "
                    :options="
                    selected == 'Inventory'
                      ? i.select2.filter(
                          item => item.isShow || i.label !== 'Trạng thái'
                        )
                      : i.select2
                  "
                    :placeholder="i.label"
                    :settings="{
                    multiple: i.multiple ? true : false,
                    closeOnSelect: i.multiple ? false : true
                  }"
                    :state="errors.length > 0 ? false : null"
                />
                <img
                    v-if="i.clearable && currentItem[i.field]"
                    alt=""
                    class="clear-input-btn"
                    src="@/assets/images/icons/close-icon.png"
                    @click="clearInput(i.field)"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col
              v-if="
              selected == 'Inventory' && textLink && currentItem.Status == 20
            "
              cols="12"
          >
            <b-form-group v-if="selected == 'Inventory'" label="Link gửi KH">
              <div class="position-relative">
                <b-form-textarea v-model="textLink" rows="3"></b-form-textarea>
                <div class="position-absolute style-icon-copy">
                  <feather-icon
                      icon="CopyIcon"
                      size="15"
                      @click="copyLink(textLink)"
                  />
                </div>
              </div>
            </b-form-group>
          </b-col>
          <b-col
              v-if="
              (selected == 'Inventory' && editMode) || selected == 'SimCategory'
            "
              cols="6"
          >
            <p for="">Tags</p>
            <input-tag v-model="tags"></input-tag>
          </b-col>
          <b-col
              v-if="selected == 'Inventory' && checkStatusPhoneChange()"
              cols="12"
          >
            <validation-provider
                #default="{ errors }"
                :rules="'required'"
                name="note"
            >
              <b-form-group label="Ghi chú">
                <b-form-input
                    v-model="editPhoneNote"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Nhập ghi chú đổi trạng thái"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col
              v-if="selected == 'B2C_Campaign'"
              class="text-primary"
              cols="12"
          >
            <div
                v-if="
                currentItem &&
                  currentItem.utm_campaign &&
                  camplibs &&
                  currentItem.channel
              "
                class="border rounded bg-light font-weight-bold p-1"
            >
              {{
                camplibs.find(i => i.CampaignName == currentItem.utm_campaign)
                    .Url
              }}?utm_source={{
                currentItem.channel.split(",")[1]
              }}&utm_medium={{
                currentItem.channel.split(",")[2]
              }}&utm_campaign={{ currentItem.utm_campaign }}
            </div>
          </b-col>
          <b-col v-if="logs && logs.length > 0" class="text-primary" cols="12">
            <h5>Logs</h5>
            <b-card body-class="p-0" class="p-0">
              <b-card-text style="overflow: auto">
                <table class="table table-bordered table-sm">
                  <tr>
                    <th>Nội dung</th>
                    <th>Thời gian</th>
                  </tr>
                  <tr v-for="i in logs" :key="i.Id">
                    <td>{{ i.Content }}</td>
                    <td>{{ i.LogDate }}</td>
                  </tr>
                </table>
              </b-card-text>
            </b-card>
          </b-col>
        </b-row>
      </validation-observer>
    </b-modal>
    <b-modal
        id="modal-import-excel"
        :title="'Import excel file'"
        ok-title="Lưu"
        size="lg"
        @ok="importExcelOk"
    >
      <b-row align-v="center" class="ml-0 mr-0">
        <b-button
            class="btn-sm mr-50"
            style="color: black"
            variant="outline-primary"
            @click="$refs.inputImportExcelFile.click()"
        >
          <feather-icon class="align-text-top" icon="UploadIcon" size="16"/>
          Upload file
        </b-button>
        <span v-if="file && file.name">{{ file.name }}</span>
        <span v-else style="color: #ed1f24">Vui lòng chọn file!</span>
        <template
            v-if="
            sampleImportExcelErrorConfig.data &&
              sampleImportExcelErrorConfig.data.length > 0
          "
        >
          <vue-excel-xlsx
              :columns="sampleImportExcelErrorConfig.columns"
              :data="sampleImportExcelErrorConfig.data"
              :file-name="'ErrorTemplate'"
              :file-type="'xlsx'"
              :sheet-name="'error'"
              class="btn btn-sm btn-outline-primary ml-auto"
              style="color: black; margin-right: 4px"
          >
            <feather-icon
                class="align-text-top"
                icon="DownloadIcon"
                size="16"
            />
            Tải file thông báo lỗi
          </vue-excel-xlsx>
        </template>
        <input
            ref="inputImportExcelFile"
            accept=".xls*"
            class="fileSelect"
            style="display: none"
            type="file"
            @change="handleChange($event)"
        />
      </b-row>
      <template #modal-footer>
        <button
            class="btn btn-sm mr-50 btn-outline-primary m-0"
            style="color: black"
            @click="download('/fileExcel/kho-so.xlsx')"
        >
          <feather-icon class="align-text-top" icon="DownloadIcon" size="16"/>
          Tải file mẫu
        </button>
        <b-button
            class="ml-auto"
            variant=""
            @click="$bvModal.hide('modal-import-excel')"
        >Cancel
        </b-button>
        <b-button class="ml-1" variant="primary" @click="importExcelOk"
        >Ok
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import {ValidationObserver, ValidationProvider} from "vee-validate";
import {required} from "@validations";
import vSelect from "vue-select";
import {VueGoodTable} from "vue-good-table";
import InputTag from "vue-input-tag";
import {
  BAvatar,
  BBadge,
  BButton,
  BCard,
  BCardText,
  BCol,
  BDropdown,
  BDropdownItem,
  BFormCheckbox,
  BFormCheckboxGroup,
  BFormDatepicker,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BFormTextarea,
  BLink,
  BMedia,
  BModal,
  BPagination,
  BRow,
  BTable,
  BTooltip,
  VBTooltip
} from "bootstrap-vue";
import useJwt from "@/auth/jwt/useJwt";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Ripple from "vue-ripple-directive";
import "@core/scss/vue/libs/vue-good-table.scss";
import Select2 from "v-select2-component";
import {$ctx} from "@themeConfig";
import XLSX from "xlsx";
import VueExcelXlsx from "vue-excel-xlsx";
import Vue from "vue";
import TableMerge from "@core/components/TableMerge.vue";

Vue.use(VueExcelXlsx);

export default {
  components: {
    BCardText,
    BFormDatepicker,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    vSelect,
    FeatherIcon,
    BModal,
    BFormGroup,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    BFormSelect,
    VueGoodTable,
    Select2,
    BFormTextarea,
    BFormCheckboxGroup,
    InputTag,
    TableMerge
  },

  directives: {
    "b-tooltip": VBTooltip,
    Ripple
  },
  async mounted() {
    await this.loadMasterData();
    var roles = JSON.parse(localStorage.userData).role.split(",");
    if (this.selected == "B2C_Campaign") {
      if (!roles.includes("MKT")) {
        this.options.find(
            i => i.value == "B2C_Campaign"
        ).fields = this.options
            .find(i => i.value == "B2C_Campaign")
            .fields.filter(f => f.field != "user");
        this.allFields = this.allFields.filter(i => i.field != "user");
        this.fields = this.fields.filter(i => i.field != "user");
      } else {
        this.options
            .find(i => i.value == "B2C_Campaign")
            .fields.find(f => f.field == "user").hidden = false;
      }
    }
  },
  computed: {
    ischeckBox() {
      return this.manySearchMonthly.length == 6 ? true : false;
    }
  },
  watch: {
    $route(to, from) {
      this.loadMasterData();
    }
  },
  methods: {
    loading(status) {
      document.querySelector("#loading-bg").style.display = status
          ? "block"
          : "none";
    },
    ResetSim50K() {
      this.loading(true);
      useJwt
          .get("reset-sim50K")
          .then(res => {
            this.loading(false);
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Reset thành công!",
                icon: "CheckSquareIcon",
                variant: "success"
              }
            });
          })
          .catch(err => {
            this.loading(false);
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Reset thất bại!",
                icon: "AlertTriangleIcon",
                variant: "danger"
              }
            });
          });
    },
    handlePage(params) {
      this.updateParams({page: params});
      this.loadItems();
    },

    handleActions(item) {
      this.Edit(item);
    },
    download(url) {
      const a = document.createElement("a");
      a.href = url;
      a.download = url.split("/").pop();
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    handleChange(event) {
      const reader = new FileReader();
      this.currentDataImportExcelFile = [];
      this.file = event.target.files ? event.target.files[0] : null;
      if (this.file) {
        reader.onload = e => {
          /* Parse data */
          const bstr = e.target.result;
          const wb = XLSX.read(bstr, {type: "binary"});
          /* Get first worksheet */
          const wsname = wb.SheetNames[0];
          const ws = wb.Sheets[wsname];
          /* Convert array of arrays */
          const data = XLSX.utils
              .sheet_to_json(ws, {header: 1})
              ?.filter(function (subArr) {
                return subArr.length > 0;
              });
          const fields = [];
          for (let i = 0; i < data.length; i++) {
            if (i === 0) {
              data[i].forEach(f => {
                // switch (f) {
                //     case "STT":
                //         f = "index";
                //         break;
                //     case "Phone":
                //         f = "phone";
                //         break;
                //     case "Tag số":
                //         f = "tags";
                //         break;
                //     case "Trạng thái":
                //         f = "status";
                //         break;
                //     case "Kênh":
                //         f = "saleChannels";
                //         break;
                //     default:
                //         break;
                // }
                if (f.includes("STT")) {
                  f = "index";
                } else if (f.includes("Phone")) {
                  f = "phone";
                } else if (f.includes("Tag số")) {
                  f = "tags";
                } else if (f.includes("Trạng thái")) {
                  f = "status";
                } else if (f.includes("Kênh")) {
                  f = "saleChannels";
                }

                fields.push(f);
              });
            } else {
              const row = {};
              for (let j = 0; j < fields.length; j++) {
                // if (fields[j] === "phone") {
                //   // Loại bỏ các ký tự không mong muốn khỏi giá trị phone
                //   row[`${fields[j]}`] = data[i][j].toString().replace(/\t/g, "");
                // } else if (fields[j] === "saleChannels") {
                //   // Chuyển đổi giá trị sang chuỗi và loại bỏ các khoảng trắng không mong muốn
                //   const saleChannels = data[i][j]
                //     .split(",")
                //     .map((channel) => channel.trim());
                //   // row[`${fields[j]}`] = saleChannels;
                //   row[`${fields[j]}`] =
                //     fields[j] === "saleChannels" ? saleChannels : data[i][j];
                // } else if (fields[j] === "tags") {
                //   // Chuyển đổi giá trị sang chuỗi và loại bỏ các khoảng trắng không mong muốn
                //   if (data[i][j]) {
                //     const tags = data[i][j].split(",").map((tag) => tag.trim());
                //     row[`${fields[j]}`] = tags;
                //   }
                // } else if (fields[j] === "status") {
                //   if (data[i][j] === undefined) {
                //     row[`${fields[j]}`] = null;
                //   } else if (
                //     data[i][j].toString() !== "0" &&
                //     data[i][j].toString() !== "99"
                //   ) {
                //     continue;
                //   } else {
                //     row[`${fields[j]}`] = data[i][j];
                //   }
                // } else {
                //   row[`${fields[j]}`] = data[i][j];
                // }
                // row[`${fields[j]}`] = data[i][j];

                if (fields[j] === "status") {
                  if (data[i][j] === undefined) {
                    row[`${fields[j]}`] = null;
                  } else if (
                      data[i][j].toString() !== "0" &&
                      data[i][j].toString() !== "99"
                  ) {

                  } else {
                    row[`${fields[j]}`] = data[i][j];
                  }
                } else {
                  row[`${fields[j]}`] = data[i][j];
                }
              }

              this.currentDataImportExcelFile.push(row);
            }
          }
        };
      }
      reader.readAsBinaryString(this.file);
    },
    importExcelOk() {
      const data = this.currentDataImportExcelFile
          // .filter(
          //   (res) =>
          //     res.status !== null &&
          //     res.saleChannels &&
          //     res.saleChannels.length > 0 &&
          //     res.phone !== null
          // )
          .map(res => {
            return {
              ...res,
              saleChannels:
                  res && res.saleChannels && res.saleChannels.length
                      ? res.saleChannels.split(",").map(channel => channel.trim())
                      : [],
              tags:
                  res && res.tags && res.tags.length
                      ? res.tags.split(",").map(tag => tag.trim())
                      : []
            };
          });
      this.isLoading = true;
      useJwt
          .post("inventory/import-info", {
            rows: data
          })
          .then(res => {
            this.isLoading = false;
            this.sampleImportExcelErrorConfig.data = [];
            if (
                res.data.result &&
                res.data.result.length &&
                res.data.result.length > 0
            ) {
              let errorText = "";
              res.data.result.forEach(i => {
                this.sampleImportExcelErrorConfig.data.push(i);
              });

              this.$toast({
                component: ToastificationContent,
                props: {
                  title:
                      "Nhập file thất bại! Vui lòng tải file thông báo lỗi để xem chi tiết.",
                  icon: "AlertTriangleIcon",
                  variant: "danger"
                }
              });
            } else {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: res.data.message,
                  icon: "CheckSquareIcon",
                  variant: "success"
                }
              });
              this.loadItems();
              this.$bvModal.hide("modal-import-excel");
            }
          });
    },
    disableTabIndexes() {
      document.querySelector(".modal-content").removeAttribute("tabindex");
    },
    handelSelectseach(item) {
      const index = this.manySearchMonthly.map(e => e.Id).indexOf(item.Id);
      if (index == -1) {
        if (this.manySearchMonthly.length === 6) {
          // this.$toast({
          //       component: ToastificationContent,
          //       props: {
          //         title: "chỉ chọn 6 cái",
          //         icon: "AlertTriangleIcon",
          //         variant: "danger",
          //       },
          // });
        } else {
          this.manySearchMonthly.push(item);
        }
      } else {
        this.manySearchMonthly.splice(index, 1);
      }
      this.currentItem = item;
      if (this.selected === "SimCategory") {
        this.currentItem.ConfigGroupIds = this.currentItem.SimGroupIds;
        // this.currentItem && this.currentItem.SimGroupIds
        //     ? this.currentItem.SimGroupIds.split(",")
        //     : [];
      }
      this.loading(true);
      useJwt
          .put("masterData/SimCategory", this.currentItem)
          .then(response => {
            this.loading(false);
          })
          .catch(error => {
            this.loading(false);
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Lỗi trong quá trình xứ lý",
                icon: "AlertTriangleIcon",
                variant: "danger"
              }
            });
          });
    },
    handelChangeStatus(item) {
      if (item.Status === 1) {
        item.Status = 0;
      } else {
        item.Status = 1;
      }
      useJwt
          .put("masterData/SimCategory", item)
          .then(response => {
            this.loadItems();
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Cập nhật trạng thái danh mục thành công!",
                icon: "CheckSquareIcon",
                variant: "primary"
              }
            });
            if (
                (response && response.data && response.data.code === 400) ||
                (response && response.data && response.data.code === 404) ||
                (response && response.data && response.data.code === 499)
            ) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Câp nhật trạng thái danh mục thất bại!",
                  icon: "AlertTriangleIcon",
                  variant: "danger"
                }
              });
            }
          })
          .catch(error => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title:
                    "Lỗi cập nhật " +
                    this.options.filter(i => i.value === this.selected)[0].text +
                    " [" +
                    error.response.data.result +
                    "]!",
                icon: "AlertTriangleIcon",
                variant: "danger"
              }
            });
          });
    },
    handleKeyUP(e, name) {
      if (
          this.selected == "Inventory" &&
          (this.currentItem.Status == 20 || this.currentItem.Status == 0) &&
          !this.editMode
      ) {
        // if()
        const key = name === "Phone" ? "phone" : "listPrice";
        if(key==="phone" || key==="listPrice"){
          if(!this.currentItem.Phone || !this.currentItem.listPrice){
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Vui lòng nhập số điện thoại với giá niêm yết",
                icon: "AlertTriangleIcon",
                variant: "danger"
              }
            })
            return

          }
          if(!this.currentItem.Phone.startsWith("087")){
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Số điện thoại phải bắt đầu bằng 087",
                icon: "AlertTriangleIcon",
                variant: "danger"
              }
            })
            return
          }
          if(this.currentItem.Phone.length!==10){
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Số điện thoại phải có 10 chữ số",
                icon: "AlertTriangleIcon",
                variant: "danger"
              }
            })
            return;
          }
        }
        this.loading(true);
        useJwt
            .get(`getInventoryFromConfig?${key}=${e.target.value}`)
            .then(response => {
              this.loading(false);
              if (response.data.code == 404) {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: `${response.data.message}`,
                    icon: "AlertTriangleIcon",
                    variant: "warning"
                  }
                });
                return false;
              }
              const {
                Months,
                Pack,
                PackPrice,
                Price,
                SimPrice,
                EsimPrice,
                SimType,
                ListPrice,
                PackCode
              } = response?.data?.result;
              this.currentItem = {
                ...this.currentItem,
                Months,
                Pack,
                PackPrice,
                Price,
                SimPrice,
                EsimPrice,
                SimType,
                listPrice:
                    name === "listPrice"
                        ? e.target.value
                        : ListPrice === null
                            ? 0
                            : ListPrice,
                PackCode
              };
            })
            .catch(error => {
              this.loading(false);
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Có lỗi trong quá trình xứ lý",
                  icon: "AlertTriangleIcon",
                  variant: "danger"
                }
              });
            });
      }
    },
    // copyLink
    async copyLink(textLink) {
      await navigator.clipboard.writeText(textLink);
      this.$toast("Đã sao chép link");
    },
    async loadMasterData() {
      this.loading(true);
      this.selected = this.$route.meta.type;
      this.fields = JSON.parse(
          JSON.stringify(
              this.options.filter(i => i.value == this.selected)[0].fields
          )
      );
      this.fields.forEach(i => {
        delete i.select2;
        delete i.cols;
        delete i.autoIncrement;
        delete i.required;
        delete i.multiple;
      });
      if (this.selected == "Inventory" || this.selected == "SimCategory") {
        useJwt
            .post("getMasterData/SimConfigGroup", {
              columnFilters: {},
              sort: [],
              page: 1,
              pageSize: 200,
              lang: 1
            })
            .then(response => {
              if (this.selected == "Inventory") {
                this.options[0].fields[9].select2 = response.data.result.map(
                    item => {
                      return {
                        ...item,
                        text: item.id
                      };
                    }
                );
              } else {
                this.fields.filter(i => {
                  i.field === "ConfigGroupId";
                })[0].filterOptions.filterDropdownItems = response.data.result.map(
                    item => {
                      return {value: item.id, text: item.group_name};
                    }
                );
              }
            });
      }
      if (this.selected === "SimConfigGroup") {
        this.getSimConfigGroup();
      }
      await this.loadItems();
      this.allFields = this.options.filter(
          i => i.value == this.selected
      )[0].fields;
      if (
          this.selected == "Inventory" ||
          this.selected == "SimCategory" ||
          this.selected == "SimConfigGroup"
      ) {
        this.fields = this.fields.filter(i => !i.notShowTable);
      }
      this.loading(false);
    },
    async getSimConfigGroup() {
      const response = await useJwt.post("getMasterData/SimCategory", {
        columnFilters: {},
        sort: [],
        page: 1,
        pageSize: 200,
        lang: 1
      });
      this.SimConfigGroupName = response;
      this.fields.filter(
          i => i.field === "CategoryId"
      )[0].filterOptions.filterDropdownItems = response.data.result.map(
          item => {
            return {text: item.Name, value: item.Id};
          }
      );
      this.options
          .filter(i => i.value == this.selected)[0]
          .fields.filter(i => i.field === "CategoryId")[0].select2 =
          response &&
          response.data.result.map(item => {
            return {text: item.Name, id: item.Id};
          });
    },
    getTitle() {
      if (this.editMode) {
        return (
            "Cập nhật " +
            this.options.filter(i => i.value === this.selected)[0].text
        );
      } else {
        return `Thêm mới  ${
            this.$route.path === "/kho-so"
                ? "số đơn lẻ"
                : this.options.filter(i => i.value == this.selected)[0].text
        }`;
      }
    },
    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },

    onPageChange(params) {
      this.updateParams({page: params.currentPage});
      this.loadItems();
    },
    onPerPageChange(params) {
      this.updateParams({pageSize: params.currentPerPage});
      this.loadItems();
    },
    onSortChange(params) {
      this.updateParams({
        sort: params
      });
      this.loadItems();
    },
    onColumnFilter(params) {
      this.serverParams.page = 1;
      this.updateParams(params);
      this.loadItems();
    },
    async loadItems() {
      this.loading(true);
      await useJwt
          .post("getMasterData/" + this.selected, this.serverParams)
          .then(response => {
            this.loading(false);
            if (response.data.result) {
              this.items = response.data.result.map(res => {
                return {
                  ...res,
                  saleChannel: res.SaleChannels?.split(",")
                };
              });
            }
            if (response.data.extra != null) {
              if (this.selected === "SimConfigGroup") {
                this.options
                    .filter(i => i.value == this.selected)[0]
                    .fields.filter(i => i.field === "CategoryIds")[0].select2 =
                    response.data.extra.SimCategory &&
                    response.data.extra.SimCategory.length > 0
                        ? response.data.extra.SimCategory.map(item => {
                          return {text: item.Name, id: item.Id};
                        })
                        : [];
              }
              if (this.selected === "SimCategory") {
                response.data.extra.ConfigGroupIds =
                    response.data.extra.SimConfigGroup;
              }
              for (var key of Object.keys(response.data.extra)) {
                try {
                  this.dataStaus = this.options
                      .filter(i => i.value == this.selected)[0]
                      .fields.filter(
                          i => i.field === key
                      )[0].select2 = response.data.extra[key].map(item => {
                    return {
                      ...item,
                      text: item.group_name
                          ? `${item.group_name} (${item.id})`
                          : item.text
                    };
                  });
                } catch (err) {
                }
              }
            }
            this.items = response.data.result;
            if (
                this.selected === "SimConfigGroup" &&
                response &&
                response.data &&
                response.data.result
            ) {
              this.items = response.data.result.map(item => {
                return {
                  ...item,
                  CategoryId: item.categories
                };
              });
            }
            this.manySearchMonthly = response.data.result.filter(
                item => item.IsManySearchMonthly === 1
            );
            if (
                this.selected === "SimCategory" &&
                response &&
                response.data &&
                response.data.result
            ) {
              this.items = response.data.result.map(item => {
                return {
                  ...item,
                  ConfigGroupId: item.SimGroups,
                  IsManySearchMonthly:
                      item.IsManySearchMonthly === 1 ? true : false
                };
              });
              // for (let i=0;i<this.items.length;i++) {
              //         if (this.items[i].SimGroupIds) {
              //             for (let j=0;j<this.items[i].SimGroupIds.length;j++) {
              //                 if (this.items[i].SimGroupIds[j]) {
              //                     response.data.extra.SimConfigGroup.map(simConfigGroup => {
              //                         if (simConfigGroup.id === parseInt(this.items[i].SimGroupIds[j])) {
              //                             this.items[i].SimGroupIds[j] = simConfigGroup.group_name;
              //                         }
              //                     })
              //                 }
              //             }
              //         }
              // }
              for (let i = 0; i < this.items.length; i++) {
                if (this.items[i].SimGroupName) {
                  this.items[i].SimGroupName = this.items[i].SimGroupName.split(
                      ","
                  );
                }
              }
            }
            this.totalRecords = response.data.totalRecords;
            this.isLoading = false;
          });

      if (this.selected == "B2C_Campaign") {
        useJwt
            .post("getMasterData/B2C_Campaign_Lib", this.serverParams)
            .then(response => {
              this.camplibs = response.data.result;
            });
      }
    },

    async Edit(item, index, button) {
      this.textLink = `${$ctx.URL_FRONTEND}/mua-sim-so-le/${item.link}`;
      this.currentItem = item;
      if (this.selected === "SimCategory") {
        this.currentItem.ConfigGroupIds =
            this.currentItem && this.currentItem.SimGroupIds
                ? this.currentItem.SimGroupIds
                : [];
        this.tags =
            this.currentItem && this.currentItem.Tags
                ? this.currentItem.Tags
                : [];
      }
      if (this.selected === "Inventory") {
        this.allFields.forEach(e => {
          e.field === "saleChannel" ||
          e.field === "Pack" ||
          e.field === "PackPrice"
              ? (e.required = false)
              : (e.required = true);
        });
        this.currentItem.saleChannel =
            this.currentItem && this.currentItem.SaleChannels
                ? this.currentItem.SaleChannels.split(",")
                : [];
        this.currentItem.listPrice = this.currentItem.ListPrice;
        this.tags =
            this.currentItem && this.currentItem.Tags
                ? this.currentItem.Tags.split(",")
                : [];
      }
      if (this.selected === "SimConfigGroup") {
      }
      this.editPhoneNote = "";
      this.editMode = true;
      this.allFields = this.options.filter(
          i => i.value == this.selected
      )[0].fields;
      if (this.selected === "Inventory") {
        useJwt
            .get(`inventory/log/${this.currentItem.Phone}`)
            .then(response => {
              this.logs = response.data.result;
            })
            .catch(error => {
            });
      }
      if (item.Status !== 20 && this.selected === "Inventory") {
        this.options[0].fields[10].select2 = this.options[0].fields[10].select2.map(
            item => {
              return {
                ...item,
                isShow: item.id != 20 ? true : false
              };
            }
        );
        this.allFields = this.allFields.filter(
            i => !i.notShowTable || i.field == "saleChannel"
        );
      } else {
        this.setCurrentItemSingleNumber();
        if (this.selected === "Inventory") {
          this.allFields = this.allFields.map(res => {
            return {
              ...res,
              disabled: res.field === "Phone" ? true : false
            };
          });
        }
      }
      // console.table(this.allFields);
      this.modal_title =
          "Cập nhật " +
          this.options.filter(i => i.value === this.selected)[0].text;
      this.$bvModal.show("modal-edit");
    },
    New() {
      this.currentItem = {};
      this.tags = [];
      this.allFields = this.options.filter(
          i => i.value == this.selected
      )[0].fields;
      if (this.selected === "Inventory") {
        this.allFields = this.allFields.filter(i => !i.isCreate);
      }
      this.allFields.forEach(e => {
        (e.field === "saleChannel" || e.field === "SimType" || e.field==="Price") ? (e.required = true) : (e.required = false);
      });
      this.textLink = "";
      this.editMode = false;
      this.setCurrentItemSingleNumber();
      this.modal_title =
          "Thêm mới " +
          this.options.filter(i => i.value === this.selected)[0].text;
      this.$bvModal.show("modal-edit");
    },
    async handleOk(bvModalEvt) {
      bvModalEvt.preventDefault();
      var validate = await this.$refs.modalEdit.validate().then(success => {
        return success;
      });
      if (!validate) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Vui lòng kiểm tra dữ liệu!",
            icon: "AlertTriangleIcon",
            variant: "warning"
          }
        });
        return;
      }
      if (this.selected == "Inventory" && this.checkStatusPhoneChange()) {
        this.currentItem = {
          ...this.currentItem,
          Note: this.editPhoneNote
        };
      }
      if (!this.editMode) {
        if (
            this.options.find(i => i.value == this.selected).newADDSingleNumber
        ) {
          this.loading(true);
          useJwt
              .put("new-number-to-inventory", {
                months: this.currentItem.Months,
                esimPrice: this.currentItem.EsimPrice === "" ? null : Number(this.currentItem.EsimPrice),
                price: this.currentItem.Price === "" ? null : Number(this.currentItem.Price),
                simPrice: this.currentItem.SimPrice === "" ? null : Number(this.currentItem.SimPrice),
                shipmentFee: this.currentItem.ShipmentFee === "" ? null : Number(this.currentItem.ShipmentFee),
                simType: this.currentItem.SimType === "" ? null : Number(this.currentItem.SimType),
                status: this.currentItem.Status,
                pack: this.currentItem.Pack,
                phone: this.currentItem.Phone === "" ? null : this.currentItem.Phone,
                packPrice: this.currentItem.PackPrice === "" ? null : this.currentItem.PackPrice,
                listPrice: this.currentItem.listPrice === "" ? null : this.currentItem.listPrice,
                packCode: this.currentItem.PackCode,
                saleChannel: this.currentItem.saleChannel,
                commitType: this.currentItem.commitType,
                commitValue: this.currentItem.commitValue
              })
              .then(response => {
                this.loadItems();
                this.loading(false);
                if (response && response.data && response.data.code === 200) {
                  if (this.currentItem.Status == 0) {
                    this.$bvModal.hide("modal-edit");
                  }
                  this.textLink = `${$ctx.URL_FRONTEND}/mua-sim-so-le/${response.data.result}`;
                  this.$toast({
                    component: ToastificationContent,
                    props: {
                      title: `${
                          this.currentItem.Status == 0
                              ? "Thêm mới số thành công!"
                              : "Thêm mới số đơn lẻ thành công!"
                      }`,
                      icon: "CheckSquareIcon",
                      variant: "primary"
                    }
                  });
                }
                if (response && response.data && response.data.code === 400) {
                  this.$toast({
                    component: ToastificationContent,
                    props: {
                      title: `${response.data.message}`,
                      icon: "AlertTriangleIcon",
                      variant: "danger"
                    }
                  });
                }
              })
              .catch(error => {
                this.loading(false);
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "Lỗi thêm mới số đơn lẻ",
                    icon: "AlertTriangleIcon",
                    variant: "danger"
                  }
                });
              });
        } else {
          if (this.selected === "SimCategory") {
            this.currentItem = {...this.currentItem, Tags: this.tags};
          }
          useJwt
              .post("masterData/" + this.selected, this.currentItem)
              .then(response => {
                this.loadItems();
                this.$bvModal.hide("modal-edit");
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title:
                        "Thêm mới " +
                        this.options.filter(i => i.value === this.selected)[0]
                            .text +
                        " thành công!",
                    icon: "CheckSquareIcon",
                    variant: "primary"
                  }
                });
              })
              .catch(error => {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title:
                        "Lỗi thêm mới " +
                        this.options.filter(i => i.value === this.selected)[0].text,
                    icon: "AlertTriangleIcon",
                    variant: "danger"
                  }
                });
              });
        }
      } else {
        if (
            this.currentItem.Status === 20 &&
            this.selected == "Inventory" &&
            this.options.find(i => i.value == this.selected).newADDSingleNumber
        ) {
          useJwt
              .put("edit-number-to-inventory", {
                months: this.currentItem.Months,
                esimPrice: Number(this.currentItem.EsimPrice),
                price: Number(this.currentItem.Price),
                simPrice: Number(this.currentItem.SimPrice),
                shipmentFee: Number(this.currentItem.ShipmentFee),
                simType: Number(this.currentItem.SimType),
                status: this.currentItem.Status,
                pack: this.currentItem.Pack,
                phone: this.currentItem.Phone,
                packPrice: this.currentItem.PackPrice,
                packCode: this.currentItem.PackCode
              })
              .then(response => {
                this.loadItems();
                this.$bvModal.hide("modal-edit");
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "Cập nhật số  đơn lẻ thành công!",
                    icon: "CheckSquareIcon",
                    variant: "primary"
                  }
                });
              })
              .catch(error => {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title:
                        "Lỗi cập nhật số  đơn lẻ" +
                        " [" +
                        error.response.data.result +
                        "]!",
                    icon: "AlertTriangleIcon",
                    variant: "danger"
                  }
                });
              });
          return;
        }
        let data = {};
        if (this.selected === "Inventory" && this.editMode) {
          data = {
            months: this.currentItem.Months,
            esimPrice: Number(this.currentItem.EsimPrice),
            price: Number(this.currentItem.Price),
            simPrice: Number(this.currentItem.SimPrice),
            shipmentFee: Number(this.currentItem.ShipmentFee),
            simType: Number(this.currentItem.SimType),
            status: this.currentItem.Status,
            pack: this.currentItem.Pack,
            phone: this.currentItem.Phone,
            packPrice: this.currentItem.PackPrice,
            listPrice: this.currentItem.listPrice,
            packCode: this.currentItem.PackCode,
            tags: this.tags,
            saleChannel: this.currentItem.saleChannel
          };
        } else if (this.selected === "SimCategory") {
          data = {...this.currentItem, Tags: this.tags};
        } else {
          data = this.currentItem;
        }
        var url = "masterData/" + this.selected;
        if (this.selected == "B2C_Campaign") url = "B2C_Campaign";
        if (this.selected == "B2C_Campaign_Channel")
          url = "B2C_Campaign_Channel";
        if (this.selected == "B2C_Campaign_Config") url = "B2C_Campaign_Config";
        if (this.selected == "SCHEDULER") url = "SCHEDULER";
        useJwt
            .put(url, data)
            .then(response => {
              this.loadItems();
              this.$bvModal.hide("modal-edit");
              this.$toast({
                component: ToastificationContent,
                props: {
                  title:
                      "Cập nhật " +
                      this.options.filter(i => i.value === this.selected)[0].text +
                      " thành công!",
                  icon: "CheckSquareIcon",
                  variant: "primary"
                }
              });
              if (
                  (response && response.data && response.data.code === 400) ||
                  (response && response.data && response.data.code === 404) ||
                  (response && response.data && response.data.code === 499)
              ) {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: `${response.data.message}`,
                    icon: "AlertTriangleIcon",
                    variant: "danger"
                  }
                });
              }
            })
            .catch(error => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title:
                      "Lỗi cập nhật " +
                      this.options.filter(i => i.value === this.selected)[0].text +
                      " [" +
                      error.response.data.result +
                      "]!",
                  icon: "AlertTriangleIcon",
                  variant: "danger"
                }
              });
            });
      }
    },
    async Delete(item, index, button) {
      this.currentItem = item;
      var res = await this.$bvModal.msgBoxConfirm(
          "Vui lòng xác nhận bạn muốn xoá dữ liệu " + this.selected,
          {title: "Please Confirm", size: "sm"}
      );
      if (res) {
        var url = `masterData/${this.selected}/${this.currentItem.id}`;
        if (this.selected == "B2C_Campaign") {
          var url = `masterData/${this.selected}/${this.currentItem.utm_id}`;
        } else if (
            this.selected == "B2C_Campaign_Config" ||
            this.selected == "B2C_Campaign_Channel" ||
            this.selected === "SimCategory"
        ) {
          var url = `masterData/${this.selected}/${this.currentItem.Id}`;
        }
        useJwt
            .delete(url, {})
            .then(response => {
              this.loadItems();
              this.$toast({
                component: ToastificationContent,
                props: {
                  title:
                      "Xoá " +
                      this.options.filter(i => i.value === this.selected)[0].text +
                      " thành công!",
                  icon: "CheckSquareIcon",
                  variant: "primary"
                }
              });
            })
            .catch(error => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title:
                      "Lỗi xoá " +
                      this.options.filter(i => i.value === this.selected)[0].text,
                  icon: "AlertTriangleIcon",
                  variant: "danger"
                }
              });
            });
      }
    },
    checkStatusPhoneChange() {
      if (this.selected == "Inventory" && this.currentItem) {
        const originItem = this.items.find(
            el => el.Phone == this.currentItem.Phone
        );
        if (originItem && originItem.Status != this.currentItem.Status) {
          return true;
        }
      }
      return false;
    },
    setCurrentItemSingleNumber() {
      if (
          this.selected == "Inventory" &&
          this.currentItem &&
          this.options.find(i => i.value == this.selected).newADDSingleNumber
      ) {
        this.currentItem.Status = 20;
        if(!this.editMode&& !this.options[0].fields[10].select2.find(item=>item.id==20)){
          this.options[0].fields[10].select2.forEach(item=>{
            if(item.id==0){
              item.isShow=true
            }
          })
          this.options[0].fields[10].select2.push(
              {
                id: "20",
                text: "Gửi link mua cho Khách hàng",
                isShow: true
              }
          );
        }
        else {
          this.options[0].fields[10].select2.forEach(item=>{
            if(item.id==20 || item.id==0){
              item.isShow=true
            }
            else {
              item.isShow=false
            }
          })
        }
        this.options[0].fields[10].select2 = this.options[0].fields[10].select2.filter(
            item => {
              return {
                ...item,
                isShow: item.id == 20
              };
            }
        );
      }
    },
    clearInput(val) {
      this.currentItem[val] = "";
    },
    exportExcel() {
      this.loading(true);
      useJwt
          .post("inventory/export-info", this.serverParams, {
            responseType: "blob"
          })
          .then(response => {
            this.loading(false);
            var fileURL = window.URL.createObjectURL(
                new Blob([response.data], {
                  type: "application/vnd.ms-excel"
                })
            );
            var fileLink = document.createElement("a");

            fileLink.href = fileURL;
            fileLink.setAttribute("download", "Danh sach so.xlsx");
            document.body.appendChild(fileLink);
            fileLink.click();
          })
          .catch(error => {
            this.loading(false);
            console.log(error);
          });
    }
  },
  data() {
    return {
      sampleImportExcelErrorConfig: {
        columns: [
          {
            field: "rowIndex",
            label: "Dòng"
          },
          {
            field: "note",
            label: "Thông báo lỗi"
          }
        ],
        data: []
      },
      currentDataImportExcelFile: [],
      file: {},
      tags: [],
      manySearchMonthly: [],
      textLink: "",
      isLoading: false,
      totalRecords: 0,
      items: [],
      editMode: false,
      totalItem: 0,
      permisItems: [],
      searchQuery: "",
      searchTerm: "",
      currentItem: {},
      selected: "Inventory",
      editPhoneNote: "",
      logs: [],
      options: [
        {
          value: "Inventory",
          text: "Quản lý số",
          DeleleEnabled: false,
          EditEnabled: true,
          NewEnabled: true,
          newADDSingleNumber: true,
          fields: [
            {
              field: "Phone",
              filterOptions: {enabled: true, placeholder: ""},
              label: "Số Itel",
              required: true,
              disabled: false
            },
            {
              field: "listPrice",
              filterOptions: {enabled: true, placeholder: ""},
              label: "Giá niêm yết",
              required: true,
              disabled: false,
              notShowTable: true
            },
            {
              field: "Price",
              filterOptions: {enabled: true, placeholder: ""},
              label: "Giá bán",
              disabled: false
            },
            {
              field: "Pack",
              filterOptions: {enabled: true, placeholder: ""},
              label: "Gói cước",
              disabled: false
            },
            {
              field: "PackPrice",
              filterOptions: {enabled: true, placeholder: ""},
              label: "Giá gói",
              disabled: false
            },
            {
              field: "Months",
              filterOptions: {enabled: true, placeholder: ""},
              label: "Tháng cam kết",
              disabled: false
            },
            {
              field: "PackCode",
              filterOptions: {enabled: true, placeholder: ""},
              label: "Mã gói",
              disabled: false,
              notShowTable: true
            },
            {
              field: "EsimPrice",
              filterOptions: {enabled: true, placeholder: ""},
              label: "Giá esim",
              disabled: false,
              notShowTable: true
            },
            {
              field: "SimPrice",
              filterOptions: {enabled: true, placeholder: ""},
              label: "Giá sim",
              disabled: false,
              notShowTable: true
            },
            // {
            //   field: "ShipmentFee",
            //   filterOptions: { enabled: true, placeholder: "" },
            //   label: "Giá vận chuyển",
            //   required: true,
            //   disabled: true,
            //   notShowTable: true,
            // },
            {
              field: "SimType",
              filterOptions: {enabled: true, placeholder: ""},
              label: "Loại số",
              notShowTable: true,
              required: true
            },
            {
              field: "Status",
              filterOptions: {
                enabled: true,
                placeholder: "",
                filterDropdownItems: [
                  {value: "0", text: "Sẵn sàng"},
                  {value: "1", text: "Đã bán - chưa kích hoạt"},
                  {value: "2", text: "Đã bán - đã kích hoạt"},
                  {value: "10", text: "iTel giữ số"},
                  {value: "11", text: "Lỗi VnPay, chờ kiểm tra"},
                  {value: "20", text: "Gửi link mua cho Khách hàng"},
                  {value: "99", text: "Tất cả"}
                ]
              },
              label: "Trạng thái",
              required: true
            },
            {
              field: "SaleChannels",
              noDisplayform: true,
              isCreate: true,
              multiple: true,
              placeholder: "",
              filterDropdownItems: [
                {value: "Website itel.vn", text: "Website itel.vn"},
                {value: "Sim Thăng Long", text: "Sim Thăng Long"},
                {value: "Momo", text: "Momo"}
              ],
              label: "Kênh",
              required: true
            },
            {
              field: "saleChannel",
              isCreate: false,
              multiple: true,
              select2: [
                {
                  text: "Website itel.vn",
                  id: "Website itel.vn"
                },
                {
                  text: "Sim Thăng Long",
                  id: "Sim Thăng Long"
                },
                {
                  text: "Momo",
                  id: "Momo"
                },
                {
                  text: "OTO",
                  id: "OTO"
                }
              ],
              label: "Kênh",
              notShowTable: true,
              required: true
            },
            {
              field: "commitType",
              isCreate: false,
              multiple: false,
              select2: [
                {
                  text: "Cam kết theo gói",
                  id: "PACK"
                },
                {
                  text: "Cam kết tài khoản chính",
                  id: "PSC"
                }
              ],
              label: "Loại cam kết",
              notShowTable: true,
              required: false
            },
            {
              field: "commitValue",
              label: "Giá trị cam kết",
              notShowTable: true,
              required: false
            },
            {
              noDisplayform: true,
              field: "Tags",
              filterOptions: {enabled: false, placeholder: ""},
              label: "Tag Số",
              disabled: true
              // notShowTable: true,
            },
            {field: "action", label: "Actions", width: "90px"}
          ]
        },
        {
          value: "ESIM",
          text: "Quản lý eSIM",
          DeleleEnabled: false,
          EditEnabled: true,
          NewEnabled: false,
          fields: [
            {
              field: "ICCID",
              filterOptions: {enabled: true, placeholder: ""},
              label: "ICCID",
              required: true,
              disabled: true
            },
            {
              field: "QRCODE",
              filterOptions: {enabled: true, placeholder: ""},
              label: "Qr Code",
              required: true,
              disabled: true
            },
            {
              field: "Status",
              filterOptions: {
                enabled: true,
                placeholder: "",
                filterDropdownItems: [
                  {value: "0", text: "Sẵn sàng"},
                  {value: "1", text: "Đã bán"},
                  {value: "100", text: "Khác"}
                ]
              },
              label: "Trạng thái",
              required: true
            },
            {field: "action", label: "Actions", width: "90px"}
          ]
        },
        {
          value: "SimConfigGroup",
          text: "Quản lý loại số",
          DeleleEnabled: false,
          EditEnabled: true,
          NewEnabled: true,
          fields: [
            {
              field: "id",
              filterOptions: {enabled: true, placeholder: ""},
              label: "Mã loại số",
              width: "120px",
              required: true,
              disabled: true
            },
            {
              field: "group_name",
              filterOptions: {enabled: true, placeholder: ""},
              label: "Tên loại số",
              required: true
            },
            {
              field: "status",
              filterOptions: {enabled: true, placeholder: ""},
              label: "Trạng thái",
              required: true,
              filterOptions: {
                enabled: true,
                placeholder: "",
                filterDropdownItems: [
                  {value: "0", text: "Không sử dụng"},
                  {value: "1", text: "Sử dụng"}
                ]
              }
            },
            {
              field: "CategoryId",
              filterOptions: {enabled: true, placeholder: ""},
              noDisplayform: true,
              label: "Danh mục số",

              required: true,
              filterOptions: {
                enabled: true,
                placeholder: "",
                filterDropdownItems: []
              }
            },
            {
              field: "CategoryIds",
              filterOptions: {enabled: true, placeholder: ""},
              label: "Danh mục số",
              multiple: true,
              notShowTable: true,
              required: true,
              filterOptions: {
                enabled: true,
                placeholder: "",
                filterDropdownItems: []
              }
            },

            {
              field: "action",
              label: "Actions",
              width: "90px",
              sortable: false
            }
          ]
        },
        {
          value: "B2C_Campaign",
          text: "Quản lý Campaign bán hàng",
          DeleleEnabled: true,
          EditEnabled: true,
          NewEnabled: true,
          fields: [
            {
              field: "utm_id",
              filterOptions: {enabled: true, placeholder: ""},
              label: "ID",
              width: "120px",
              required: true,
              disabled: true
            },
            {
              field: "utm_campaign",
              filterOptions: {enabled: true, placeholder: ""},
              label: "Campaign Name"
            },
            {
              field: "utm_content",
              filterOptions: {enabled: true, placeholder: ""},
              label: "UTM Content",
              required: true
            },
            {
              field: "channel",
              filterOptions: {enabled: true, placeholder: ""},
              label: "Channel",
              required: true
            },

            {
              field: "user",
              filterOptions: {enabled: true, placeholder: ""},
              label: "Agency",
              multiple: true,
              required: true,
              cols: 12
            },
            {
              field: "action",
              label: "Actions",
              width: "90px",
              tdClass: "text-center"
            }
          ]
        },
        {
          value: "SCHEDULER",
          text: "Quản lý tiến trình",
          DeleleEnabled: true,
          EditEnabled: true,
          NewEnabled: true,
          fields: [
            {
              field: "ID",
              filterOptions: {enabled: true, placeholder: ""},
              label: "Job ID",
              width: "120px",
              required: true,
              disabled: true
            },
            {
              field: "JOB_TYPE",
              filterOptions: {enabled: true, placeholder: ""},
              label: "Loại job",
              required: true,
              filterOptions: {
                enabled: true,
                placeholder: "",
                filterDropdownItems: [
                  {value: "SQL", text: "SQL Proc"},
                  {value: "Java", text: "Java Method"},
                  {value: "Groovy", text: "Groovy Script"}
                ]
              }
            },
            {
              field: "CRON",
              filterOptions: {enabled: true, placeholder: ""},
              label: "Lịch chạy",
              required: true
            },
            {
              field: "SCRIPT",
              filterOptions: {enabled: true, placeholder: ""},
              label: "Script",
              required: true
            },
            {
              field: "DB",
              filterOptions: {enabled: true, placeholder: ""},
              label: "Database"
            },
            {
              field: "LOG_TYPE",
              filterOptions: {enabled: true, placeholder: ""},
              label: "Kiểu ghi Log",
              required: true,
              filterOptions: {
                enabled: true,
                placeholder: "",
                filterDropdownItems: [
                  {value: "HAS_RESULT", text: "Chạy có kết quả"},
                  {value: "ALL", text: "Tất cả"}
                ]
              }
            },
            {
              field: "STATUS",
              filterOptions: {enabled: true, placeholder: ""},
              label: "Trạng thái",
              required: true,
              filterOptions: {
                enabled: true,
                placeholder: "",
                filterDropdownItems: [
                  {value: "0", text: "Inactive"},
                  {value: "1", text: "Active"}
                ]
              }
            },
            {
              field: "action",
              label: "Actions",
              width: "90px",
              tdClass: "text-center"
            }
          ]
        },
        {
          value: "SCHEDULE_LOGS",
          text: "Log tiến trình",
          DeleleEnabled: false,
          EditEnabled: false,
          NewEnabled: false,
          fields: [
            {
              field: "ID",
              filterOptions: {enabled: true, placeholder: ""},
              label: "Job ID",
              width: "120px",
              required: true,
              disabled: true
            },
            {
              field: "JOB_TYPE",
              filterOptions: {enabled: true, placeholder: ""},
              label: "Loại job",
              required: true,
              filterOptions: {
                enabled: true,
                placeholder: "",
                filterDropdownItems: [
                  {value: "SQL", text: "SQL Proc"},
                  {value: "Java", text: "Java Method"},
                  {value: "Groovy", text: "Groovy Script"}
                ]
              },
              disabled: true
            },
            {
              field: "SCRIPT",
              filterOptions: {enabled: true, placeholder: ""},
              label: "Script",
              required: true,
              disabled: true
            },
            {
              field: "STARTTIME",
              filterOptions: {enabled: true, placeholder: ""},
              label: "Start Time",
              required: true,
              disabled: true
            },
            {
              field: "ENDTIME",
              filterOptions: {enabled: true, placeholder: ""},
              label: "End Time",
              required: true,
              disabled: true
            },
            {
              field: "RESULT",
              filterOptions: {enabled: true, placeholder: ""},
              label: "Kết quả",
              required: true,
              disabled: true
            },
            {
              field: "action",
              label: "Actions",
              width: "90px",
              tdClass: "text-center"
            }
          ]
        },
        {
          value: "B2C_Campaign_Config",
          text: "Quản lý thư viện Campaign",
          DeleleEnabled: true,
          EditEnabled: true,
          NewEnabled: true,
          fields: [
            {
              field: "Id",
              filterOptions: {enabled: true, placeholder: ""},
              label: "Id",
              width: "120px",
              required: true,
              disabled: true
            },
            {
              field: "CampaignName",
              filterOptions: {enabled: true, placeholder: ""},
              label: "Campaign Name",
              width: "120px",
              required: true
            },
            {
              field: "StartTime",
              filterOptions: {enabled: false, placeholder: ""},
              label: "Bắt đầu",
              required: true,
              date_time: true,
              tdClass: "text-center"
            },
            {
              field: "EndTime",
              filterOptions: {enabled: false, placeholder: ""},
              label: "Kết thúc",
              required: false,
              date_time: true,
              tdClass: "text-center"
            },
            {
              field: "Status",
              filterOptions: {enabled: true, placeholder: ""},
              label: "Trạng thái",
              required: true,
              filterOptions: {
                enabled: true,
                placeholder: "",
                filterDropdownItems: [
                  {value: "0", text: "Inactive"},
                  {value: "1", text: "Active"}
                ]
              }
            },
            {
              field: "Url",
              filterOptions: {enabled: true, placeholder: ""},
              label: "Link",
              required: true
            },
            {
              field: "action",
              label: "Actions",
              width: "90px",
              tdClass: "text-center"
            }
          ]
        },
        {
          value: "B2C_Campaign_Channel",
          text: "Quản lý kênh quảng cáo",
          DeleleEnabled: true,
          EditEnabled: true,
          NewEnabled: true,
          fields: [
            {
              field: "Id",
              filterOptions: {enabled: true, placeholder: ""},
              label: "Id",
              width: "120px",
              required: true,
              disabled: true
            },
            {
              field: "utm_source",
              filterOptions: {enabled: true, placeholder: ""},
              label: "UTM Source",
              width: "120px",
              required: true
            },
            {
              field: "utm_medium",
              filterOptions: {enabled: true, placeholder: ""},
              label: "UTM Medium",
              required: true,
              cols: 12
            },
            {
              field: "action",
              label: "Actions",
              width: "90px",
              tdClass: "text-center"
            }
          ]
        },
        {
          value: "SimCategory",
          text: "Quản lý danh mục số",
          DeleleEnabled: true,
          EditEnabled: true,
          NewEnabled: true,
          fields: [
            {
              field: "Id",
              filterOptions: {enabled: true, placeholder: ""},
              label: "Id",
              width: "90px",
              required: true,
              disabled: true,
              noDisplayform: true
            },
            {
              field: "Name",
              filterOptions: {enabled: true, placeholder: ""},
              label: "Tên danh mục số",
              required: true
            },
            // {
            //     field: "SimGroupIds",
            //     noDisplayform: true,
            //     label: "Các loại số trong danh mục",
            //     multiple: true,
            //     filterOptions: {
            //         enabled: true,
            //         placeholder: "",
            //         filterDropdownItems: [],
            //     },
            //     disabled: true,
            // },
            {
              field: "SimGroupName",
              noDisplayform: true,
              label: "Các loại số trong danh mục",
              multiple: true,
              filterOptions: {
                enabled: true,
                placeholder: "",
                filterDropdownItems: []
              },
              disabled: true
            },
            {
              field: "Status",
              filterOptions: {enabled: true, placeholder: ""},
              label: "Trạng thái",
              required: true,
              filterOptions: {
                enabled: true,
                placeholder: "",
                filterDropdownItems: [
                  {value: 0, text: "Không sử dụng"},
                  {value: 1, text: "Sử dụng"}
                ]
              },
              clearable: true
            },
            {
              field: "ConfigGroupIds",
              label: "Danh mục này bao gồm các nhóm số:",
              notShowTable: true,
              multiple: true,
              filterOptions: {
                enabled: true,
                placeholder: "",
                filterDropdownItems: []
              },
              disabled: true
            },
            {
              field: "LoaiThueBao",
              isCreate: true,
              select2: [
                {
                  text: "Cam kết",
                  id: "CamKet"
                },
                {
                  text: "Thường",
                  id: "Thuong"
                }
              ],
              label: "Loại thuê bao",
              notShowTable: true,
              required: false,
              clearable: true
            },
            {
              field: "KenhBan",
              isCreate: true,
              select2: [
                {
                  text: "Website itel.vn",
                  id: "Website itel.vn"
                },
                {
                  text: "Sim Thăng Long",
                  id: "Sim Thăng Long"
                },
                {
                  text: "Momo",
                  id: "Momo"
                }
              ],
              label: "Kênh",
              notShowTable: true,
              required: false,
              clearable: true
            },
            {
              field: "Menh",
              isCreate: true,
              select2: [
                {
                  text: "Kim",
                  id: "Kim"
                },
                {
                  text: "Mộc",
                  id: "Mộc"
                },
                {
                  text: "Thủy",
                  id: "Thủy"
                },
                {
                  text: "Hỏa",
                  id: "Hỏa"
                },
                {
                  text: "Thổ",
                  id: "Thổ"
                }
              ],
              label: "Mệnh",
              notShowTable: true,
              required: false,
              clearable: true
            },
            {
              field: "SoNut",
              isCreate: true,
              select2: [
                {
                  text: "1",
                  id: "1"
                },
                {
                  text: "2",
                  id: "2"
                },
                {
                  text: "3",
                  id: "3"
                },
                {
                  text: "4",
                  id: "4"
                },
                {
                  text: "5",
                  id: "5"
                },
                {
                  text: "6",
                  id: "6"
                },
                {
                  text: "6",
                  id: "6"
                },
                {
                  text: "7",
                  id: "7"
                },
                {
                  text: "8",
                  id: "8"
                },
                {
                  text: "9",
                  id: "9"
                },
                {
                  text: "10",
                  id: "10"
                }
              ],
              label: "Nút",
              notShowTable: true,
              required: false,
              clearable: true
            },
            {
              field: "Logic",
              isCreate: true,
              select2: [
                {
                  text: "Giao",
                  id: "AND"
                },
                {
                  text: "Hợp",
                  id: "OR"
                }
              ],
              label: "Hình thức",
              notShowTable: true,
              required: true,
              clearable: true
            },
            {
              field: "seachMoth",
              filterOptions: {enabled: true, placeholder: ""},
              label: "Tim kiếm nhiều trong tháng",
              tdClass: "text-center",
              noDisplayform: true,
              sortable: false
            },
            {
              field: "action",
              label: "Actions",
              width: "90px",
              tdClass: "text-center",
              sortable: false
            }
          ]
        },
        {
          value: "Tag",
          text: "Quản lý tag",
          DeleleEnabled: false,
          EditEnabled: true,
          NewEnabled: false,
          newADDSingleNumber: true,
          fields: [
            {
              field: "Phone",
              filterOptions: {enabled: true, placeholder: ""},
              label: "Số thuê bao",
              required: true,
              disabled: true
            },
            {
              field: "Status",
              filterOptions: {
                enabled: true,
                placeholder: "",
                filterDropdownItems: [
                  {value: "0", text: "Sẵn sàng"},
                  {value: "1", text: "Đã bán - chưa kích hoạt"},
                  {value: "2", text: "Đã bán - đã kích hoạt"},
                  {value: "10", text: "iTel giữ số"},
                  {value: "11", text: "Lỗi VnPay, chờ kiểm tra"},
                  {value: "20", text: "Gửi link mua cho Khách hàng"}
                ]
              },
              label: "Trạng thái",
              required: true
            },
            {
              field: "listPrice",
              filterOptions: {enabled: true, placeholder: ""},
              label: "Giá số",
              required: true,
              disabled: true,
              notShowTable: true
            },
            {
              field: "Price",
              filterOptions: {enabled: true, placeholder: ""},
              label: "Loại thuê bao",
              disabled: true
            },
            {
              field: "Pack",
              filterOptions: {enabled: true, placeholder: ""},
              label: "Loại số",
              disabled: true
            },
            {
              field: "PackPrice",
              filterOptions: {enabled: true, placeholder: ""},
              label: "Danh mục số",
              disabled: true
            },
            {
              field: "Months",
              filterOptions: {enabled: true, placeholder: ""},
              label: "Kênh",
              disabled: true
            },
            {
              field: "PackCode",
              filterOptions: {enabled: true, placeholder: ""},
              label: "Mệnh sim",
              disabled: true,
              notShowTable: true
            },
            {
              field: "EsimPrice",
              filterOptions: {enabled: true, placeholder: ""},
              label: "Số nút",
              disabled: true,
              notShowTable: true
            },
            {
              field: "SimPrice",
              filterOptions: {enabled: true, placeholder: ""},
              label: "Bộ sưu tập",
              disabled: true,
              notShowTable: true
            },

            {field: "action", label: "Actions", width: "90px"}
          ]
        }
      ],
      fields: [],
      allFields: [],
      dataStaus: [],
      serverParams: {
        columnFilters: {},
        sort: [],
        page: 1,
        pageSize: 50
      },
      camplibs: [],
      required,
      SimConfigGroupName: {}
    };
  }
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";

.style-icon-copy {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  top: 1px;
  right: 0px;
  color: red;
  cursor: pointer;

  &:hover {
    border-radius: 50%;
    background-color: rgba(237, 31, 36, 0.12);
  }
}

::v-deep textarea.form-control {
  padding: 0.8rem 2rem 0.8rem 1rem !important;
}

.clear-input-btn {
  position: absolute;
  right: 13%;
  top: 50%;
  cursor: pointer;
  color: #999;
}
</style>
